/**
 * Created by andrey on 25.07.17.
 */

cleverapps.LocalizationManager = {
    run: function () {
        const save = cleverapps.dataLoader.load(DataLoader.TYPES.LOCALIZATION_MANAGER);
        if (save === undefined && this.hasInconsistentLanguage() || this.hasFirstInitLanguageWindow()) {
            this.displayLanguageWindow();
        }
    },

    hasInconsistentLanguage: function () {
        const language = cleverapps.settings.language;
        const availableLanguages = cleverapps.config.languages;
        const defaultLanguage = cleverapps.Settings.getDefaultLanguage();

        return language !== defaultLanguage && availableLanguages.indexOf(defaultLanguage) >= 0;
    },

    hasFirstInitLanguageWindow: function () {
        return levels.user.currentPhysicalLevel.episode === 0 && levels.user.currentPhysicalLevel.level === 0 && connector.platform.oneOf(connector.GDCOM, connector.COOLMATHGAMES) && cleverapps.config.name === "riddles";
    },

    displayLanguageWindow: function () {
        cleverapps.focusManager.displayWhenFreeFocus({
            focus: "displayInconsistentLanguage",
            filter: function () {
                return !cleverapps.config.importMode;
            },
            action: function (f) {
                cleverapps.dataLoader.save(DataLoader.TYPES.LOCALIZATION_MANAGER, 1);
                new LanguagesWindow();

                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    }
};
